import styled from 'styled-components';

export const StyledAppWrapper = styled.div`
	width: 100%;
	min-height: 94.8vh;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: start;
	background-color: #282c34;
	font-size: 1rem;
	line-height: 1.25rem;
	color: white;
	padding-top: 3rem;
`;
